export class ItemCodeModel {
    item_no: number
    item_code: string
    item_desc: string

    constructor(
        item_no: number,
        item_code: string,
        item_desc: string,
    ) {
        this.item_no = item_no
        this.item_code = item_code
        this.item_desc = item_desc
    }
}

export class ItemOrderModel {
    order_no: number
    order_code: string
    vendor: string
    vendor_code: string
    item_type: number

    vendor_name: any
    unit_per_issue: any
    issue_container: any
    method_of_issue: any
    unit_per_container: any
    container_type: any
    _default: boolean

    private _options: string

    public get options(): string {
        return `${this.vendor_name} : ${this.unit_per_issue} ${this.method_of_issue} / ${this.issue_container} -- ${this.unit_per_container} / ${this.container_type}`;
    }

    public set options(options: string) {
        this._options = options;
    }

    constructor(
        order_no: number,
        order_code: string,
        vendor: string,
        vendor_code: string,
        item_type: number,
        vendor_name: any,
        unit_per_issue: any,
        issue_container: any,
        method_of_issue: any,
        unit_per_container: any,
        container_type: any,
        _default: boolean
    ) {
        this.order_no = order_no
        this.order_code = order_code
        this.vendor = vendor
        this.vendor_code = vendor_code
        this.item_type = item_type
        this.vendor_name = vendor_name
        this.unit_per_issue = unit_per_issue
        this.issue_container = issue_container
        this.method_of_issue = method_of_issue
        this.unit_per_container = unit_per_container
        this.container_type = container_type
        this._default = _default
    }
}

export class ItemOrderDetailsModel {
    order_no: number
    order_code: string
    item_no: number
    item_type: string
    vendor: string
    vendor_code: string
    method_of_issue: string
    unit_per_issue: number
    issue_container: string
    unit_per_container: number
    container_type: string
    container_cost: number
    order_item_active: boolean
    order_item_modified_date: string
    _default: boolean
    item_code: string
    vendor_visible: string
    manufacturer_code: string
    clinic_no?: number

    constructor(
        order_no: number,
        order_code: string,
        item_no: number,
        item_type: string,
        vendor: string,
        vendor_code: string,
        method_of_issue: string,
        unit_per_issue: number,
        issue_container: string,
        unit_per_container: number,
        container_type: string,
        container_cost: number,
        order_item_active: boolean,
        order_item_modified_date: string,
        _default: boolean,
        item_code: string,
        manufacturer_code: string,
        clinic_no?: number
    ) {
        this.order_no = order_no
        this.order_code = order_code
        this.item_no = item_no
        this.item_type = item_type
        this.vendor = vendor
        this.vendor_code = vendor_code
        this.method_of_issue = method_of_issue
        this.unit_per_issue = unit_per_issue
        this.issue_container = issue_container
        this.unit_per_container = unit_per_container
        this.container_type = container_type
        this.container_cost = container_cost
        this.order_item_active = order_item_active
        this.order_item_modified_date = order_item_modified_date
        this._default = _default
        this.item_code = item_code
        this.manufacturer_code = manufacturer_code
        this.clinic_no = clinic_no
    }
}
